import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import Auth from '../../../../../../routes/Auth';

import { getProductNameColor, getProductRowColor } from '../../../../../../api/PerformanceFeedback';
import { handleSelectChange, arrayUniqueFilter } from '../../../utils';

import {
  Table,
  Row,
  Cell
} from '../../../components/ui';

import BannerLayout from '../../../layouts/banner';

class MarketShareStep4 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      products: []
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Product market fit").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      getRequest(
        `${process.env.REACT_APP_API_URL}team/products/?round_number=${activeRound}&team_id=${team_id}`
      ).then(res => {
        const products = res.body;

        const productsFiltered = products.filter(i => Number(i.round) === roundId);

        this.setState({
          loaded: true,
          teamsToShow,
          selectedTeamId: Number(team_id),
          allTeamsCount: teams.length,
          products: productsFiltered
        })
      })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      products
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Market share"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams developed a product that met the interest of a few customers with a much smaller demand size`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p><a href="/">Real World Article</a></p>
            <p>Pursuing a smaller demand size makes it challenging for teams to hit their market share target since 1) other teams are likely competing for the same opportunity and 2) customers, in this game, prefer to buy from multiple vendors to reduce concentration risks.</p>
            <p>In their round feedback, these teams were advised to 1) review the <a href="/">Customer Analysis</a> to ensure their product features’ attract a larger demand size and 2) consider upgrading their products to go after a larger opportunity.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <Table>
              <Row background="#2a4169">
                <Cell color="#ffffff" />
                <Cell color="#ffffff">Resolution</Cell>
                <Cell color="#ffffff">Sensitivity</Cell>
                <Cell color="#ffffff">Power</Cell>
                <Cell color="#ffffff">Temp Range</Cell>
              </Row>
              {products.map((product, index) => (
                <Row background={getProductRowColor(index)} key={index}>
                  <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{product.name}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.pixels_rank}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.sensitivity_rank}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.power_rank}</Cell>
                  <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.temp_range_rank}</Cell>
                </Row>
              ))}
            </Table>
          </Fragment>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default MarketShareStep4;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/market-share/step4.js